import React from 'react'
import Loading from "../../components/common/Loading";
import switchStyles from "../../styles/desktopMobileSwitch.module.css";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";
import IcecreamParlor from '@/components/outlet/IcecreamParlor';

const icecreamParlor = () => {
  return (
    <>
      <Head>
        <title>Billing Software for Ice Cream Parlours | Efficient & Fast</title>
        <link rel="canonical" href="https://queuebuster.co/outlet/icecream-parlor" />
        <link rel="alternate" href="https://queuebuster.co/outlet/icecream-parlor" hrefLang="en-us" />
        <meta name="description" content="Boost your ice cream parlor with QB Billing Software. Enjoy fast billing, efficient inventory management, and easy online store setup for a seamless experience." />
        <meta property="og:title" content="QueueBuster Billing Software for Ice Cream Parlors | Streamlined Management" />
        <meta property="og:description" content="Unlock the full potential of your ice cream parlor with QueueBuster's billing software. Enjoy fast, accurate billing, efficient inventory management, and effortless online store setup. Manage vendors, track sales, and generate detailed reports to enhance your business operations and customer satisfaction." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/OG%2BImages%2Bwebsite%2Bpages-06.jpg" />
        <meta property="og:url" content="https://queuebuster.co/outlet/icecream-parlor" />
      </Head>
         <SchemaTags page="icecream-parlor" />
      <IcecreamParlor />
    </>
  )
}

export default icecreamParlor